module.exports = __webpack_public_path__ + "c1f0089a692500bb3ce580fdd8d80a59.svg";